import React, {useState} from 'react';
import Dialog from '../adapters/Dialog'
import Button from '../adapters/Button';

import {useDispatch} from "react-redux";
//import {toggleModal} from '../../redux/application';

import {restorePassword} from '../../redux/user';
import Grid from "@material-ui/core/Grid";
import TextField from '../adapters/TextField';
import {Form, FormSpy} from "react-final-form";
import {makeStyles} from "@material-ui/core/styles";
import {validateEmail} from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      //marginTop: theme.spacing(3),
    }
  })
);

export default function ChangePasswordAskEmail({open, toggle}) {

  const dispatch = useDispatch();
  const [hasErrors, toggleHasErrors] = useState(false);

  //см. https://final-form.org/docs/react-final-form/faq
  //How can I trigger a submit from outside my form?
  let submit;

  async function submitRegister(values) {
    if (await dispatch(restorePassword(values)))
      toggle(false);
  }

  function validate(values) {
    let errors = {};
    if (!values.login)
      errors.login = 'Необхідно заповнити поле "Логін (адреса електронної пошти)"';
    if (values.login && validateEmail(values.login))
      errors.login = 'Введено некоректну адресу електронної пошти';
    return errors;
  }

  const classes = useStyles();

  const content =
    <Form
      onSubmit={submitRegister}
      validate={validate}
      render={({handleSubmit, hasValidationErrors}) => {
        submit = handleSubmit;
        return (
          <form className={classes.form} onSubmit={handleSubmit} noValidate>
            <Grid container>
              <Grid item xs={12}>
                <TextField name="login" label="Логін (адреса електронної пошти)" required/>
              </Grid>
            </Grid>
            <FormSpy subscription={{hasValidationErrors: true}}
                     onChange={props => {
                       //Говнокод inside
                       //Состояние формы недоступно извне формы, а нам очень хочется
                       //FormSpy будет рендерится когда поменяется hasValidationErrors
                       //В этот момент мы пропихиваем в стейт значение этого флага
                       //Без form spy это был бы бесконечный цикл, а так один лишний рендер
                       //setTimeout нужен чтобы подавить ворнинг реакта что мы мол в рендеринге меняем стейт
                       setTimeout(() => toggleHasErrors(props.hasValidationErrors), 0)
                     } }
            />
          </form>
        )
      }}
    />


  const actions = <React.Fragment>
    <Button disabled={hasErrors} onClick={() => submit()}>Надіслати запит </Button>
    <Button onClick={() => toggle(false)}> Відмінити </Button>
  </React.Fragment>;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      title="Зміна паролю"
      content={content}
      actions={actions}
    />)

}